import { render, staticRenderFns } from "./RemindConfig.vue?vue&type=template&id=1dd2ddca&scoped=true"
import script from "./RemindConfig.vue?vue&type=script&lang=js"
export * from "./RemindConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2ddca",
  null
  
)

export default component.exports